import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import FastClick from 'fastclick'
import AwesomePicker from 'vue-awesome-picker'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {Alert, Confirm} from 'wc-messagebox'
import Calendar from 'vue-mobile-calendar'
import Vant from 'vant';



import './assets/js/rem_750.js'
import 'vant/lib/index.css';
import 'wc-messagebox/style.css'
import 'styles/reset.css'
import 'styles/border.css'
import 'styles/iconfont.css'


Vue.use(ElementUI)
Vue.use(Alert)
Vue.use(Confirm)
Vue.use(AwesomePicker)
Vue.use(Vant);
Vue.use(Calendar)
FastClick.attach(document.body)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js